<template>
  <default>
    <div class="cust-travel-wrap">
      <travel-plan-select-page channel="customer" />
    </div>
  </default>
</template>

<script>
import Default from '@/components/layout/Default';
import TravelPlanSelectPage from '@/components/travel/TravelPlanSelectPage';

export default {
  name: 'CustomerTravelPlanSelect',
  components: { Default, TravelPlanSelectPage },
  metaInfo: { title: 'Travel Insurance — Select Cover' },
};
</script>

<style src="@/assets/css/customer-travel.css"></style>
